var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayQrLogo = function SvgPayQrLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 44,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 37,
    x: 6,
    y: 4,
    fill: "#fff",
    fillOpacity: 0.9,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2B343C",
    clipPath: "url(#PayQrLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.071 8H9v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.142 8H10.07v1.074h1.072zM12.216 8h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 8h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 8h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.427 8h-1.072v1.074h1.072zM16.501 8H15.43v1.074H16.5zM18.642 8H17.57v1.074h1.072zM19.716 8h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.786 8h-1.071v1.074h1.071zM25.071 8H24v1.074h1.071zM30.427 8h-1.072v1.074h1.072zM32.571 8H31.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 8H32.57v1.074h1.072zM34.716 8h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.786 8h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.857 8h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.927 8h-1.072v1.074h1.072zM10.071 9.074H9v1.074h1.071zM16.501 9.074H15.43v1.074H16.5zM18.642 9.074H17.57v1.074h1.072zM20.786 9.074h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.857 9.074h-1.072v1.074h1.072zM24.001 9.074H22.93v1.074H24zM26.142 9.074H25.07v1.074h1.072zM27.216 9.074h-1.072v1.074h1.072zM29.357 9.074h-1.072v1.074h1.072zM37.927 9.074h-1.072v1.074h1.072zM10.071 10.147H9v1.074h1.071zM12.216 10.147h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 10.147h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 10.147h-1.072v1.074h1.072zM16.501 10.147H15.43v1.074H16.5zM18.642 10.147H17.57v1.074h1.072zM21.857 10.147h-1.072v1.074h1.072zM24.001 10.147H22.93v1.074H24zM29.357 10.147h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 10.147h-1.072v1.074h1.072zM33.642 10.147H32.57v1.074h1.072zM34.716 10.147h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.786 10.147h-1.071v1.074h1.071zM37.927 10.147h-1.072v1.074h1.072zM10.071 11.223H9v1.074h1.071zM12.216 11.223h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 11.223h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 11.223h-1.072v1.074h1.072zM16.501 11.223H15.43v1.074H16.5zM24.001 11.223H22.93v1.074H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.071 11.223H24v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.142 11.223H25.07v1.074h1.072zM27.216 11.223h-1.072v1.074h1.072zM30.427 11.223h-1.072v1.074h1.072zM33.642 11.223H32.57v1.074h1.072zM34.716 11.223h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.786 11.223h-1.071v1.074h1.071zM37.927 11.223h-1.072v1.074h1.072zM10.071 12.297H9v1.074h1.071zM12.216 12.297h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 12.297h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 12.297h-1.072v1.074h1.072zM16.501 12.297H15.43v1.074H16.5zM22.927 12.297h-1.072v1.074h1.072zM25.071 12.297H24v1.074h1.071zM29.357 12.297h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 12.297h-1.072v1.074h1.072zM33.642 12.297H32.57v1.074h1.072zM34.716 12.297h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.786 12.297h-1.071v1.074h1.071zM37.927 12.297h-1.072v1.074h1.072zM10.071 13.371H9v1.074h1.071zM16.501 13.371H15.43v1.074H16.5zM18.642 13.371H17.57v1.074h1.072zM19.716 13.371h-1.072v1.074h1.072zM24.001 13.371H22.93v1.074H24zM26.142 13.371H25.07v1.074h1.072zM28.286 13.371h-1.071v1.074h1.071zM30.427 13.371h-1.072v1.074h1.072zM37.927 13.371h-1.072v1.074h1.072zM10.071 14.445H9v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.142 14.443H10.07v1.074h1.072zM12.216 14.443h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 14.443h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 14.443h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.427 14.443h-1.072v1.074h1.072zM16.501 14.443H15.43v1.074H16.5zM18.642 14.443H17.57v1.074h1.072zM19.716 14.443h-1.072v1.074h1.072zM21.857 14.443h-1.072v1.074h1.072zM24.001 14.443H22.93v1.074H24zM26.142 14.443H25.07v1.074h1.072zM28.286 14.443h-1.071v1.074h1.071zM30.427 14.443h-1.072v1.074h1.072zM32.571 14.445H31.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 14.443H32.57v1.074h1.072zM34.716 14.443h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.786 14.443h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.857 14.443h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.927 14.443h-1.072v1.074h1.072zM18.642 15.518H17.57v1.074h1.072zM19.716 15.518h-1.072v1.074h1.072zM22.927 15.518h-1.072v1.074h1.072zM25.071 15.518H24v1.074h1.071zM28.286 15.518h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.357 15.518h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 15.518h-1.072v1.074h1.072zM12.216 16.592h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 16.592h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 16.592h-1.072v1.074h1.072zM16.501 16.592H15.43v1.074H16.5zM18.642 16.592H17.57v1.074h1.072zM22.927 16.592h-1.072v1.074h1.072zM24.001 16.592H22.93v1.074H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.071 16.592H24v1.074h1.071zM28.286 16.592h-1.071v1.074h1.071zM30.427 16.592h-1.072v1.074h1.072zM31.501 16.592H30.43v1.074H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.571 16.592H31.5v1.074h1.071zM35.786 16.592h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.857 16.592h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.927 16.592h-1.072v1.074h1.072zM10.071 17.668H9v1.074h1.071zM13.286 17.668h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 17.668h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.427 17.668h-1.072v1.074h1.072zM16.501 17.668H15.43v1.074H16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.571 17.668H16.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.642 17.668H17.57v1.074h1.072zM20.786 17.668h-1.071v1.074h1.071zM22.927 17.668h-1.072v1.074h1.072zM25.071 17.668H24v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.142 17.668H25.07v1.074h1.072zM28.286 17.668h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.357 17.668h-1.072v1.074h1.072zM34.716 17.668h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.786 17.668h-1.071v1.074h1.071zM10.071 18.74H9v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.142 18.74H10.07v1.074h1.072zM13.286 18.74h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 18.74h-1.072v1.074h1.072zM20.786 18.74h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.857 18.74h-1.072v1.074h1.072zM24.001 18.74H22.93v1.074H24zM27.216 18.74h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.286 18.74h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.357 18.74h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 18.74h-1.072v1.074h1.072zM32.571 18.74H31.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 18.74H32.57v1.074h1.072zM13.286 19.815h-1.071v1.073h1.071zM15.427 19.815h-1.072v1.073h1.072zM16.501 19.815H15.43v1.073H16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.571 19.815H16.5v1.073h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.642 19.815H17.57v1.073h1.072zM19.716 19.815h-1.072v1.073h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.786 19.815h-1.071v1.073h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.857 19.815h-1.072v1.073h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.927 19.815h-1.072v1.073h1.072zM24.001 19.815H22.93v1.073H24zM26.142 19.815H25.07v1.073h1.072zM27.216 19.815h-1.072v1.073h1.072zM30.427 19.815h-1.072v1.073h1.072zM31.501 19.815H30.43v1.073H31.5zM33.642 19.815H32.57v1.073h1.072zM34.716 19.815h-1.072v1.073h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.786 19.815h-1.071v1.073h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.857 19.815h-1.072v1.073h1.072zM11.142 20.889H10.07v1.074h1.072zM14.357 20.889h-1.072v1.074h1.072zM19.716 20.889h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.786 20.889h-1.071v1.074h1.071zM22.927 20.889h-1.072v1.074h1.072zM25.071 20.889H24v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.142 20.889H25.07v1.074h1.072zM27.216 20.889h-1.072v1.074h1.072zM29.357 20.889h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 20.889h-1.072v1.074h1.072zM33.642 20.889H32.57v1.074h1.072zM34.716 20.889h-1.072v1.074h1.072zM36.857 20.889h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.927 20.889h-1.072v1.074h1.072zM11.142 21.96H10.07v1.075h1.072zM14.357 21.96h-1.072v1.075h1.072zM16.501 21.96H15.43v1.075H16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.571 21.96H16.5v1.075h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.642 21.96H17.57v1.075h1.072zM19.716 21.96h-1.072v1.075h1.072zM22.927 21.96h-1.072v1.075h1.072zM24.001 21.96H22.93v1.075H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.071 21.96H24v1.075h1.071zM27.216 21.96h-1.072v1.075h1.072zM29.357 21.96h-1.072v1.075h1.072zM32.571 21.96H31.5v1.075h1.071zM35.786 21.96h-1.071v1.075h1.071zM37.927 21.96h-1.072v1.075h1.072zM10.071 23.04H9v1.073h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.142 23.04H10.07v1.073h1.072zM13.286 23.04h-1.071v1.073h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 23.04h-1.072v1.073h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.427 23.04h-1.072v1.073h1.072zM17.571 23.04H16.5v1.073h1.071zM19.716 23.04h-1.072v1.073h1.072zM21.857 23.04h-1.072v1.073h1.072zM24.001 23.04H22.93v1.073H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.071 23.04H24v1.073h1.071zM27.216 23.04h-1.072v1.073h1.072zM29.357 23.04h-1.072v1.073h1.072zM32.571 23.04H31.5v1.073h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 23.04H32.57v1.073h1.072zM35.786 23.04h-1.071v1.073h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.857 23.04h-1.072v1.073h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.927 23.04h-1.072v1.073h1.072zM11.142 24.111H10.07v1.074h1.072zM14.357 24.111h-1.072v1.074h1.072zM16.501 24.111H15.43v1.074H16.5zM18.642 24.111H17.57v1.074h1.072zM19.716 24.111h-1.072v1.074h1.072zM21.857 24.111h-1.072v1.074h1.072zM24.001 24.111H22.93v1.074H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.071 24.111H24v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.142 24.111H25.07v1.074h1.072zM27.216 24.111h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.286 24.111h-1.071v1.074h1.071zM30.427 24.111h-1.072v1.074h1.072zM31.501 24.111H30.43v1.074H31.5zM36.857 24.111h-1.072v1.074h1.072zM10.071 25.186H9v1.074h1.071zM12.216 25.186h-1.071v1.074h1.071zM14.357 25.186h-1.072v1.074h1.072zM17.571 25.186H16.5v1.074h1.071zM19.716 25.186h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.786 25.186h-1.071v1.074h1.071zM22.927 25.186h-1.072v1.074h1.072zM29.357 25.186h-1.072v1.074h1.072zM31.501 25.186H30.43v1.074H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.571 25.186H31.5v1.074h1.071zM34.716 25.186h-1.072v1.074h1.072zM36.857 25.186h-1.072v1.074h1.072zM10.071 26.26H9v1.074h1.071zM12.216 26.26h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 26.26h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 26.26h-1.072v1.074h1.072zM16.501 26.26H15.43v1.074H16.5zM18.642 26.26H17.57v1.074h1.072zM19.716 26.26h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.786 26.26h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.857 26.26h-1.072v1.074h1.072zM27.216 26.26h-1.072v1.074h1.072zM31.501 26.26H30.43v1.074H31.5zM35.786 26.26h-1.071v1.074h1.071zM10.071 27.332H9v1.074h1.071zM13.286 27.332h-1.071v1.074h1.071zM15.427 27.332h-1.072v1.074h1.072zM17.571 27.332H16.5v1.074h1.071zM25.071 27.332H24v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.142 27.332H25.07v1.074h1.072zM27.216 27.332h-1.072v1.074h1.072zM29.357 27.332h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 27.332h-1.072v1.074h1.072zM32.571 27.332H31.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 27.332H32.57v1.074h1.072zM34.716 27.332h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.786 27.332h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.857 27.332h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.927 27.332h-1.072v1.074h1.072zM10.071 28.408H9v1.074h1.071zM12.216 28.408h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 28.408h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 28.408h-1.072v1.074h1.072zM16.501 28.408H15.43v1.074H16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.571 28.408H16.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.642 28.408H17.57v1.074h1.072zM20.786 28.408h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.857 28.408h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.927 28.408h-1.072v1.074h1.072zM24.001 28.408H22.93v1.074H24zM28.286 28.408h-1.071v1.074h1.071zM30.427 28.408h-1.072v1.074h1.072zM31.501 28.408H30.43v1.074H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.571 28.408H31.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 28.408H32.57v1.074h1.072zM34.716 28.408h-1.072v1.074h1.072zM36.857 28.408h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.927 28.408h-1.072v1.074h1.072zM18.642 29.482H17.57v1.075h1.072zM24.001 29.482H22.93v1.075H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.071 29.482H24v1.075h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.142 29.482H25.07v1.075h1.072zM29.357 29.482h-1.072v1.075h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 29.482h-1.072v1.075h1.072zM33.642 29.482H32.57v1.075h1.072zM34.716 29.482h-1.072v1.075h1.072zM37.927 29.482h-1.072v1.075h1.072zM10.071 30.555H9v1.074h1.071zM16.501 30.557H15.43v1.074H16.5zM21.857 30.557h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.927 30.557h-1.072v1.074h1.072zM24.001 30.557H22.93v1.074H24zM26.142 30.557H25.07v1.074h1.072zM27.216 30.557h-1.072v1.074h1.072zM29.357 30.557h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 30.557h-1.072v1.074h1.072zM33.642 30.557H32.57v1.074h1.072zM34.716 30.557h-1.072v1.074h1.072zM37.927 30.557h-1.072v1.074h1.072zM10.071 31.629H9v1.074h1.071zM12.216 31.629h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 31.629h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 31.629h-1.072v1.074h1.072zM16.501 31.629H15.43v1.074H16.5zM18.642 31.629H17.57v1.074h1.072zM19.716 31.629h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.786 31.629h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.857 31.629h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.927 31.629h-1.072v1.074h1.072zM29.357 31.629h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 31.629h-1.072v1.074h1.072zM31.501 31.629H30.43v1.074H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.571 31.629H31.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 31.629H32.57v1.074h1.072zM10.071 32.703H9v1.074h1.071zM12.216 32.703h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 32.703h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 32.703h-1.072v1.074h1.072zM16.501 32.703H15.43v1.074H16.5zM18.642 32.703H17.57v1.074h1.072zM20.786 32.703h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.857 32.703h-1.072v1.074h1.072zM25.071 32.703H24v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.142 32.703H25.07v1.074h1.072zM27.216 32.703h-1.072v1.074h1.072zM30.427 32.703h-1.072v1.074h1.072zM31.501 32.703H30.43v1.074H31.5zM33.642 32.703H32.57v1.074h1.072zM34.716 32.703h-1.072v1.074h1.072zM10.071 33.777H9v1.074h1.071zM12.216 33.777h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 33.777h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 33.777h-1.072v1.074h1.072zM16.501 33.777H15.43v1.074H16.5zM18.642 33.777H17.57v1.074h1.072zM19.716 33.777h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.786 33.777h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.857 33.777h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.927 33.777h-1.072v1.074h1.072zM24.001 33.777H22.93v1.074H24zM27.216 33.777h-1.072v1.074h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.286 33.777h-1.071v1.074h1.071zM31.501 33.777H30.43v1.074H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.571 33.777H31.5v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 33.777H32.57v1.074h1.072zM35.786 33.777h-1.071v1.074h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.857 33.777h-1.072v1.074h1.072zM10.071 34.854H9v1.074h1.071zM16.501 34.854H15.43v1.074H16.5zM22.927 34.854h-1.072v1.074h1.072zM24.001 34.854H22.93v1.074H24zM28.286 34.854h-1.071v1.074h1.071zM30.427 34.854h-1.072v1.074h1.072zM31.501 34.854H30.43v1.074H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.571 34.854H31.5v1.074h1.071zM35.786 34.854h-1.071v1.074h1.071zM37.927 34.854h-1.072v1.074h1.072zM10.071 35.926H9V37h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.142 35.926H10.07V37h1.072zM12.216 35.926h-1.071V37h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.286 35.926h-1.071V37h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.357 35.926h-1.072V37h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.427 35.926h-1.072V37h1.072zM16.501 35.926H15.43V37H16.5zM19.716 35.926h-1.072V37h1.072zM22.927 35.926h-1.072V37h1.072zM25.071 35.926H24V37h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.142 35.926H25.07V37h1.072zM29.357 35.926h-1.072V37h1.072z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.427 35.926h-1.072V37h1.072zM31.501 35.926H30.43V37H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.571 35.926H31.5V37h1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 35.926H32.57V37h1.072zM34.716 35.926h-1.072V37h1.072z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PayQrLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 8h30v29H9z"
  })))));
};
export default SvgPayQrLogo;